import { PageShell, Section } from "@/components/PageShell";

export default function Accessibility() {
  return (
    <PageShell
      title="Accessibility"
      subtitle="Our commitment to making CommandCenterADHD usable for everyone."
      testid="accessibility-page"
    >
      <Section heading="Our goal">
        <p>
          We want CommandCenterADHD to be usable by as many people as possible,
          including people who use keyboards, screen readers, or other assistive
          technology. We aim to meet the WCAG 2.2 AA standard across our
          storefront and purchase flows.
        </p>
      </Section>

      <Section heading="What we do">
        <p>
          We use labelled form fields, visible focus indicators, keyboard
          reachable controls, meaningful text alternatives, and colour contrast
          that meets WCAG AA for body text. Dialogs move focus in and back out,
          and can be closed with the Escape key.
        </p>
      </Section>

      <Section heading="Known limitations">
        <p>
          Accessibility is ongoing work. Some third party embedded content, such
          as the Notion workspace, is outside our direct control. If you hit a
          barrier, please tell us and we will help you get what you need.
        </p>
      </Section>

      <Section heading="Contact us">
        <p>
          Email{" "}
          <a href="mailto:support@commandcenteradhd.com" className="text-[#F5A623] underline">
            support@commandcenteradhd.com
          </a>{" "}
          with any accessibility problem or request, and we will respond and, where
          possible, provide the information in a format that works for you.
        </p>
      </Section>
    </PageShell>
  );
}
